import React, {
  createContext,
  useMemo
} from 'react';
import proptypes from 'prop-types';
import { useConditionalPromotion } from '../hooks/useConditionalPromotion';

const {
  arrayOf, node, shape, string, bool, number, oneOfType
} = proptypes;

export const defaultModelContext = {
  rewardTiers: [{
    maxAllowedRewardAmount: 0,
    minThresholdVal: 0,
    thresholdType: '',
    rewardVal: 0,
    rewardType: '',
    rewardLevel: ''
  }],
  promotionTags: '',
  subExperience: '',
  sourceEligibilityCriteria: {},
  targetEligibilityCriteria: {}
};

export const PromoModelContext = createContext(defaultModelContext);

export const PromoModelProvider = ({
  itemId,
  promotion,
  hideGiftCardPromotion,
  children
}) => {

  const {
    subExperience,
    rewardTiers,
    sourceEligibilityCriteria,
    targetEligibilityCriteria
  } = useConditionalPromotion({ promotion });

  const contextValue = useMemo(() => {
    if (!promotion) {
      return {
        ...defaultModelContext
      };
    }
    return {
      itemId,
      hideGiftCardPromotion,
      subExperience,
      rewardTiers,
      sourceEligibilityCriteria,
      targetEligibilityCriteria
    };
  }, [
    promotion,
    itemId,
    hideGiftCardPromotion,
    subExperience,
    rewardTiers,
    sourceEligibilityCriteria,
    targetEligibilityCriteria
  ]);

  return (
    <PromoModelContext.Provider value={contextValue}>
      {(!promotion)
        ? (
          <div />
        ) : children}
    </PromoModelContext.Provider>
  );
};

PromoModelProvider.displayName = 'PromoModelProvider';

PromoModelProvider.propTypes = {
  itemId: string.isRequired,
  promotion: shape({
    promotionId: oneOfType([string, number]),
    skuItemGroup: string,
    promotionTags: arrayOf(string),
    eligibilityCriteria: arrayOf(shape({
      itemGroup: string,
      minThresholdVal: number,
      thresholdType: string
    })),
    reward: shape({
      tiers: arrayOf(shape({
        minThresholdVal: number,
        thresholdType: string,
        rewardVal: number,
        rewardType: string,
        rewardLevel: string,
        maxAllowedRewardAmount: number
      }))
    })
  }).isRequired,
  children: node.isRequired,
  hideGiftCardPromotion: bool
};
